import React, {useCallback, useState} from 'react';

import {useAlertCriteria} from 'src/modules/profile/user/tabs/content/alerts/hooks/useAlertCriteria';
import {SCOPE_KEY} from 'src/modules/profile/user/tabs/content/alerts/util';
import {AlertPageRequest} from 'src/openapi/admin/models/AlertPageRequest';
import {AlertSortField} from 'src/openapi/admin/models/AlertSortField';
import {GeneralAlertType} from 'src/openapi/admin/models/GeneralAlertType';

import ComboBox, {ComboboxItem} from '@pb/kit-component-combo-box';
import {SortHeaderFilter} from '@pb/kit-component-filters';
import Label from '@pb/kit-component-label';
import {Cell} from '@pb/kit-component-table';

import {apiToUiSort, uiToApiSort} from '../../utils/util';

export const AlertItemTypeHeader = () => {
    const initialState = React.useMemo(() => ({generalAlertTypes: []}), []);
    const [request, setRequest] = useState<Partial<AlertPageRequest>>(initialState);
    const {criteria, setSort, setCriteria} = useAlertCriteria(SCOPE_KEY);
    const direction =
        criteria?.alertSortField === AlertSortField.GENERAL_ALERT_TYPE
            ? apiToUiSort(criteria.sortDirection)
            : undefined;

    const onCancel = useCallback(() => (
        setRequest(criteria?.generalAlertTypes
            ? {generalAlertTypes: criteria.generalAlertTypes}
            : initialState)
    ), [criteria?.generalAlertTypes, setRequest, initialState]);

    return (
        <Cell className="text-align_center">
            <SortHeaderFilter
                caption="Item Type"
                filterActive={
                    criteria?.generalAlertTypes ? criteria?.generalAlertTypes.length > 0 : undefined
                }
                sortable={true}
                direction={direction}
                defaultDirection="ASC"
                onSort={dir => setSort(AlertSortField.GENERAL_ALERT_TYPE, uiToApiSort(dir))}
                onCancel={onCancel}
                onReset={() => {
                    setRequest({generalAlertTypes: []});
                    setCriteria({generalAlertTypes: []});
                }}
                onApply={() => setCriteria(request)}>
                <div>
                    <Label>Item Type</Label>
                    <ComboBox<GeneralAlertType, GeneralAlertType>
                        value={request?.generalAlertTypes ? request.generalAlertTypes[0] : undefined}
                        onChange={vals => setRequest({generalAlertTypes: Array.isArray(vals) ? vals : [vals]})}
                        placeholder="Select item type">
                        <ComboboxItem
                            caption="Saved Search"
                            value={GeneralAlertType.SAVED_SEARCH}
                        />
                        <ComboboxItem
                            caption="Saved List"
                            value={GeneralAlertType.SAVED_LIST}
                        />
                    </ComboBox>
                </div>
            </SortHeaderFilter>
        </Cell>
    );
};
